import React from 'react'
import styles from './styles.module.scss'

function ReplyButtonPure({ count, isExpanded, renderIcon, renderChevronIcon, onClick }) {
  return (
    <button
      type='button'
      onClick={onClick}
      className={`${styles.replyButton} ${isExpanded ? styles.expanded : styles.collapsed}`}>
      {count > 0 && <span className={styles.count}>{count}</span>}
      {renderIcon && renderIcon()}
      {renderChevronIcon && renderChevronIcon()}
    </button>
  )
}

export default ReplyButtonPure
